import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

import Component from '../../components/component/component';

import './carousel.scss';

export default class Carousel extends Component {
    static initSelector: string = '.js-carousel';

    arrows: boolean;
    list: HTMLElement;
    autoplay: boolean;
    currentImg: HTMLElement;
    splide: Splide;
    mobileWidth: number;
    mobileHeight: number;
    desktopWidth: number;
    desktopHeight: number;

    constructor(target: HTMLElement) {
        super(target);

        this.list = this.element.querySelector('.carousel__list');
        this.arrows = this.list.hasAttribute('data-arrows');
        this.autoplay = this.list.hasAttribute('data-autoplay');

        this.mobileWidth = parseInt(this.list.getAttribute('data-mobile-width'));
        this.mobileHeight = parseInt(this.list.getAttribute('data-mobile-height'));
        this.desktopWidth = parseInt(this.list.getAttribute('data-desktop-width'));
        this.desktopHeight = parseInt(this.list.getAttribute('data-desktop-height'));

        this.init();
    }

    init(): void {
        this.splide = new Splide('.carousel__inner', {
            arrows: this.arrows,
            autoplay: this.autoplay,
            breakpoints: {
                1089: {
                    arrows: false,
                },
            },
            classes: {
                arrow: 'splide__arrow carousel__arrow',
                next: 'splide__arrow--next carousel__arrow--next',
                page: 'splide__pagination__page carousel__dot',
                pagination: 'splide__pagination carousel__dots',
                prev: 'splide__arrow--prev carousel__arrow--prev',
            },
            gap: 24,
            height: this.calculateSliderHeight(),
            perPage: 1,
            type: 'loop',
        });

        this.splide.mount();

        window.addEventListener(('resize'), () => {
            this.splide.options = {
                height: this.calculateSliderHeight(),
            };
        });
    }

    calculateSliderHeight(): number {
        if (window.innerWidth < 768) {
            const multiplier: number = this.list.clientWidth / this.mobileWidth;

            return this.mobileHeight * multiplier;
        } else {
            const multiplier: number = this.list.clientWidth / this.desktopWidth;

            return this.desktopHeight * multiplier;
        }
    }
}

